// Apply a theme to the document. The CSS variable VALUES come from the
// generated stylesheet (every theme's vars are present at all times,
// keyed by [data-theme]); this just flips the attributes that select the
// active one + the bits CSS can't express:
//
//   data-theme     → which generated var block wins.
//   data-labelcase → "upper" | "none": whether `.uppercase` labels stay
//                    capitalised or render as typed (index.css).
//   data-flat      → toggles the "kill all backdrop-blur" rule for flat
//                    themes (material.flat).
//   color-scheme + meta theme-color → native form controls + the mobile
//                 address-bar tint.
//
// Mirrors the no-flash inline script in index.html (which runs first,
// pre-React); this keeps everything in sync once React owns it and
// re-applies instantly when the user switches themes in Settings.

import { getTheme } from "./themes";

export function applyTheme(name: string): void {
  if (typeof document === "undefined") return;
  const theme = getTheme(name);
  const el = document.documentElement;
  el.setAttribute("data-theme", theme.name);
  el.setAttribute("data-labelcase", theme.typography.label.case);
  el.toggleAttribute("data-flat", theme.material.flat);
  el.style.colorScheme = theme.mode;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", theme.browserChrome);
}
